import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import Products from '@/views/Products'
import About from '@/views/About'
import HelpCenter from '@/views/HelpCenter'
import HelpDetails from '@/views/help/HelpDetails'
import HelpList from '@/views/help/HelpList'
import HelpResult from '@/views/help/HelpResult'
import Faqs from '@/views/Faqs'
import Details from '@/views/Details'
import Exception404 from '@/views/exception/404'
import LegalTerms from '@/views/legal/LegalTerms'
import LegalPrivacy from '@/views/legal/LegalPrivacy'
import Integrations from '@/views/Integrations'
import Careers from '@/views/Careers'
import Blog from '@/views/Blog'
import {getWebLimitConfig} from '@/api'
import {syncRouteSeo} from '@/utils/seoHead'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: 'Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/index',
      name: 'IndexAlias',
      component: Index,
      meta: {
        title: 'Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/Index',
      redirect: '/index'
    },
    {
      path: '/products/category/*',
      name: 'Products',
      component: Products,
      meta: {
        title: 'Products | Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/products',
      name: 'Products',
      component: Products,
      meta: {
        title: 'Products | Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/about',
      name: 'About Us',
      component: About,
      meta: {
        title: 'About Us | Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/help',
      name: 'Help Center',
      component: HelpCenter,
      meta: {
        title: 'Help Center | Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/help/list/:link',
      name: 'HelpList',
      component: HelpList,
      meta: {
        title: 'Help List | Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/help/details/:link',
      name: 'HelpDetails',
      component: HelpDetails,
      meta: {
        title: 'Help List | Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/help/search-results',
      name: 'HelpResult',
      component: HelpResult,
      meta: {
        title: 'Help Result | Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/faqs',
      name: 'Faqs',
      component: Faqs,
      meta: {
        title: 'FAQS | Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/details/:id',
      name: 'Details',
      component: Details,
      meta: {
        title: 'Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/products/:name',
      name: 'Details',
      component: Details,
      meta: {
        title: 'Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    /*   {
         path: '/legal/:link',
         name: 'LegalDetails',
         component: LegalDetails,
         meta: {
           title: 'Printbelle | Enterprise print-on-demand solutions'
         }
       },*/
    {
      path: '/legal/terms',
      name: 'LegalTerms',
      component: LegalTerms,
      meta: {
        title: 'Printbelle | Enterprise print-on-demand solutions'
      }
    },
    {
      path: '/legal/privacy',
      name: 'LegalPrivacy',
      component: LegalPrivacy,
      meta: {
        title: 'Printbelle | Enterprise print-on-demand solutions'
      }
    },
    {
      path: '/integrations',
      name: 'Integrations',
      component: Integrations,
      meta: {
        title: 'Integrations | Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/careers',
      name: 'Careers',
      component: Careers,
      meta: {
        title: 'Careers | Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/blog/:lang',
      name: 'Blog',
      component: Blog,
      meta: {
        title: 'Blog | Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/blog/:lang/:id',
      name: 'BlogDetail',
      component: () => import('@/views/BlogDetail.vue'),
      meta: {
        title: 'Blog Detail | Printbelle: Create Print on Demand Products & Fulfillment Service'
      }
    },
    {
      path: '/404',
      name: '404',
      component: Exception404,
      meta: {title: '404'}
    },
    {
      path: '/mobile/*', name: 'mobile', hidden: true
    },
    {
      path: '*', redirect: '/404', hidden: true
    }
  ]
})

// 访问限制判断处理
router.beforeEach((to, from, next) => {
  if (to.path === '/404') {
    next()
  } else {
    if (to.path.startsWith('/mobile/')) {
      let url = process.env.VUE_APP_MERCHANT + 'user/' + to.path.substr(8)
      // 激活找回密码等需要携带参数，需要一并提交过去
      if (to.query && Object.keys(to.query).length > 0) {
        url += '?1=1'
        Object.keys(to.query).forEach(key => {
          url += '&' + key + '=' + to.query[key]
        })
      }
      window.location.href = url.replace('?1=1&', '?').replace('?1=1', '?')
      return
    } else {
      const browserLang = navigator.language || navigator.userLanguage
      getWebLimitConfig().then((resp) => {
        if (resp.data && browserLang.startsWith('zh')) {
          next({path: '/404'})
        } else {
          next()
        }
      }).catch((error) => {
        next({path: '/404'})
      })
    }
  }
})

router.afterEach((to) => {
  if (to.path === '/404' || to.path.startsWith('/mobile/')) return
  syncRouteSeo(to.path, to.meta && to.meta.title)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js